export type PaymentMethodQuote = {
  paymentMethodId: string;
  code: string;
  name: string;
  description: string | null;
  settlementType: 'Manual' | 'Gateway';
  gatewayProvider: string | null;
  fee: number;
};

type ApiPaymentMethodQuote = {
  PaymentMethodId: string;
  Code: string;
  Name: string;
  Description: string | null;
  SettlementType: 'Manual' | 'Gateway';
  GatewayProvider: string | null;
  Fee: number;
};

type ApiResponse<T> = T & { ok: boolean; message?: string };

async function parseJsonResponse<T>(response: Response): Promise<T> {
  const data = (await response.json().catch(() => ({}))) as ApiResponse<T>;
  if (!response.ok || data.ok === false) {
    throw new Error(data.message || '資料載入失敗，請稍後再試。');
  }
  return data as T;
}

function normalize(item: ApiPaymentMethodQuote): PaymentMethodQuote {
  return {
    paymentMethodId: item.PaymentMethodId,
    code: item.Code,
    name: item.Name,
    description: item.Description,
    settlementType: item.SettlementType,
    gatewayProvider: item.GatewayProvider,
    fee: item.Fee,
  };
}

/**
 * 結帳頁使用：依目前的「商品小計＋運費」取得所有上架中且金流設定已就緒的付款方式與各自的手續費報價
 * （後台已建立但金鑰尚未設定完成的線上金流方式，後端會自動過濾掉，不會出現在這裡）。
 */
export async function fetchPaymentMethods(feeBase: number): Promise<PaymentMethodQuote[]> {
  const data = await fetch(`/api/payment-methods?Subtotal=${encodeURIComponent(String(Math.max(0, feeBase)))}`, {
    credentials: 'include',
    headers: { Accept: 'application/json' },
  }).then((response) => parseJsonResponse<{ ok: boolean; PaymentMethods: ApiPaymentMethodQuote[] }>(response));
  return data.PaymentMethods.map(normalize);
}

export type PaymentRedirect = {
  ActionUrl: string;
  Fields: Record<string, string>;
  Method: string;
};

/** 訂單建立成功後，若選擇的是線上金流付款方式，把瀏覽器導向金流商付款頁（動態組一個表單自動送出）。 */
export function submitPaymentRedirect(redirect: PaymentRedirect): void {
  const form = document.createElement('form');
  form.method = redirect.Method || 'POST';
  form.action = redirect.ActionUrl;
  form.style.display = 'none';

  Object.entries(redirect.Fields).forEach(([key, value]) => {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = key;
    input.value = value;
    form.appendChild(input);
  });

  document.body.appendChild(form);
  form.submit();
}
